import { TableModel, Columns } from '@leverege/ui-attributes';
import { ValueCache } from '@leverege/value-cache';
const INCLUDE_TAG = 'include:table';
const cache = new ValueCache();
function create(blueprint, subtype) {
  const {
    model
  } = blueprint;
  const subId = subtype ? `.${subtype}` : '';
  const type = `${model.alias}${subId}`;
  return {
    id: `${model.alias}${subId}.TableModelConfigurer`,
    configure: (tableModel, objectType, addName, cxt) => {
      if (type !== objectType) {
        return tableModel;
      }
      if (cache.isSame(model, subtype, addName)) {
        return cache.value;
      }
      const allColumns = Columns.getColumnsFor(`${model.alias}${subId}`).map(col => col.create());
      let tModel = tableModel || TableModel.create();
      const columns = [];
      if (subtype === 'history') {
        const timeAttr = allColumns.find(col => col.attrName === `${blueprint.historyType}.time`);
        if (timeAttr) {
          columns.push(timeAttr);
        }
      }
      if (addName) {
        const nameAttr = allColumns.find(col => col.attrName === 'name');
        if (nameAttr) {
          columns.push(nameAttr);
        }
      }
      if (model.metadata?.tableColumns) {
        model.metadata?.tableColumns.forEach(col => {
          columns.push(col);
        });
      } else if (model.attributes) {
        model.attributes.forEach(attr => {
          if (attr.tags && attr.tags.includes(INCLUDE_TAG)) {
            const colAttr = allColumns.find(col => col.attrName === `${model.alias}${subId}.${attr.name}`);
            if (colAttr) {
              columns.push(colAttr);
            }
          }
        });
      }
      tModel = TableModel.setColumns(tModel, columns);
      return cache.set(tModel, model, subtype, addName);
    }
  };
}
const BlueprintAnalyzer = {
  id: 'blueprint.TableModelConfigurer',
  sort: 100,
  processBlueprints(molten, blueprints) {
    blueprints.forEach(b => {
      molten.addPlugin('TableModelConfigurer', create(b));
      molten.addPlugin('TableModelConfigurer', create(b, 'history'));
    });
  }
};
export default {
  create,
  BlueprintAnalyzer
};